function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg124Angola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "232.598,221.075 247.067,231.574 241.554,248.579 256.01,238.063 270.48,248.563    264.944,231.563 279.402,221.046 261.525,221.057 255.99,204.058 250.475,221.064  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M298.666,182.099c-13.449-7.765-28.153-11.43-42.666-11.404v22.255   c10.728-0.019,21.595,2.688,31.536,8.427c30.119,17.389,40.476,56.04,23.086,86.158c-17.388,30.119-56.04,40.476-86.158,23.087   c-8.774-5.065-15.858-11.944-21.08-19.882l-18.584,12.27c7.066,10.739,16.662,20.037,28.533,26.891   c40.75,23.526,93.04,9.515,116.567-31.234C353.427,257.918,339.416,205.626,298.666,182.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M206.792,241.16c-5.9,10.786-1.939,24.313,8.846,30.214l72.299,39.506   c-4.916,8.988-2.306,19.927,6.682,24.843l19.531,10.683c8.988,4.917,20.261,1.616,25.178-7.372l10.683-19.529L206.792,241.16z"
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg124Angola);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiLz4KPHJlY3Qgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMjU2Ii8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMjMyLjU5OCwyMjEuMDc1IDI0Ny4wNjcsMjMxLjU3NCAyNDEuNTU0LDI0OC41NzkgMjU2LjAxLDIzOC4wNjMgMjcwLjQ4LDI0OC41NjMgICAgMjY0Ljk0NCwyMzEuNTYzIDI3OS40MDIsMjIxLjA0NiAyNjEuNTI1LDIyMS4wNTcgMjU1Ljk5LDIwNC4wNTggMjUwLjQ3NSwyMjEuMDY0ICAiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBkPSJNMjk4LjY2NiwxODIuMDk5Yy0xMy40NDktNy43NjUtMjguMTUzLTExLjQzLTQyLjY2Ni0xMS40MDR2MjIuMjU1ICAgYzEwLjcyOC0wLjAxOSwyMS41OTUsMi42ODgsMzEuNTM2LDguNDI3YzMwLjExOSwxNy4zODksNDAuNDc2LDU2LjA0LDIzLjA4Niw4Ni4xNThjLTE3LjM4OCwzMC4xMTktNTYuMDQsNDAuNDc2LTg2LjE1OCwyMy4wODcgICBjLTguNzc0LTUuMDY1LTE1Ljg1OC0xMS45NDQtMjEuMDgtMTkuODgybC0xOC41ODQsMTIuMjdjNy4wNjYsMTAuNzM5LDE2LjY2MiwyMC4wMzcsMjguNTMzLDI2Ljg5MSAgIGM0MC43NSwyMy41MjYsOTMuMDQsOS41MTUsMTE2LjU2Ny0zMS4yMzRDMzUzLjQyNywyNTcuOTE4LDMzOS40MTYsMjA1LjYyNiwyOTguNjY2LDE4Mi4wOTl6Ii8+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgZD0iTTIwNi43OTIsMjQxLjE2Yy01LjksMTAuNzg2LTEuOTM5LDI0LjMxMyw4Ljg0NiwzMC4yMTRsNzIuMjk5LDM5LjUwNiAgIGMtNC45MTYsOC45ODgtMi4zMDYsMTkuOTI3LDYuNjgyLDI0Ljg0M2wxOS41MzEsMTAuNjgzYzguOTg4LDQuOTE3LDIwLjI2MSwxLjYxNiwyNS4xNzgtNy4zNzJsMTAuNjgzLTE5LjUyOUwyMDYuNzkyLDI0MS4xNnoiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };